import { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Dropdown, MainButton, Tooltip, Theme } from '@bizzabo/design-system';
import cn from 'clsx';

interface MeetDropdownProps {
    meetButton: React.ReactNode;
    tooltipText: string;
    isMeetNowDisabled: boolean;
    onMeetNowHandle: () => void;
    onScheduleClick: () => void;
}

const MeetDropdown: React.FC<MeetDropdownProps> = ({
    meetButton,
    tooltipText,
    isMeetNowDisabled,
    onMeetNowHandle,
    onScheduleClick,
}) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const anchorRef = useRef<HTMLDivElement>(null);
    const classes = useStyles();

    const onMeetNowClick = () => {
        if (tooltipText) {
            setIsTooltipOpen(true);
        }
        if (isMeetNowDisabled) {
            return;
        }
        onMeetNowHandle();
    };

    return (
        <Dropdown placement="bottom-end" button={() => meetButton}>
            {(closeDropdown: () => void) => (
                <div className={classes.dropdownMenuContent}>
                    <Tooltip
                        open={isTooltipOpen}
                        anchorRef={anchorRef}
                        setOpen={setIsTooltipOpen}
                        text={tooltipText}
                    >
                        <div ref={anchorRef}>
                            <MainButton
                                className={cn(classes.menuButton, {
                                    [classes.disabled]: isMeetNowDisabled,
                                })}
                                onClick={() => {
                                    onMeetNowClick();
                                }}
                            >
                                Meet Now
                            </MainButton>
                        </div>
                    </Tooltip>

                    <MainButton
                        onClick={() => {
                            closeDropdown();
                            onScheduleClick();
                        }}
                        className={classes.menuButton}
                    >
                        Schedule for later
                    </MainButton>
                </div>
            )}
        </Dropdown>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        dropdownMenuContent: {
            padding: '6px 10px 8px 10px',
            boxShadow: '0px 4px 14px rgba(64, 64, 64, 0.1)',
            borderRadius: 12,
            backgroundColor: theme.palette.greys[100],
        },
        menuButton: {
            ...theme.typography.t81,
            height: 26,
            border: 0,
            borderRadius: 6,
            width: '100%',
            '& *': {
                textAlign: 'left',
            },
            marginTop: 4,
        },
        disabled: {
            cursor: 'default',
            opacity: 0.3,
            '&:hover': {
                background: 'none',
            },
        },
    }),
    { classNamePrefix: 'meet-button-dropdown' }
);

export default MeetDropdown;
